import React from "react";

export const IconsSearch = () => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Search Rooms</title>

      <path
        d="M11.3448 22.1897C17.0581 22.1897 21.6897 17.5581 21.6897 11.8448C21.6897 6.13154 17.0581 1.5 11.3448 1.5C5.63154 1.5 1 6.13154 1 11.8448C1 17.5581 5.63154 22.1897 11.3448 22.1897Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />

      <path
        d="M18.2414 18.7414L26 26.5"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const IconsSearchMobile = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Search Rooms</title>

      <path
        d="M11.3448 22.1897C17.0581 22.1897 21.6897 17.5581 21.6897 11.8448C21.6897 6.13154 17.0581 1.5 11.3448 1.5C5.63154 1.5 1 6.13154 1 11.8448C1 17.5581 5.63154 22.1897 11.3448 22.1897Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />

      <path
        d="M18.2414 18.7414L26 26.5"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const IconsCalender = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125 17.0208 19.8042 16.55 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875 8.47917 10.0958 8.7167 10 9 10.2833 10 9.52083 10.0958 9.7125 10.2875 9.90417 10.7167 10 10.7167 10 10.7167 10 10.7167 10Z"
        fill="#151515"
      />
    </svg>
  );
};

export const IconsCall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#1A1A1A"
    >
      <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" />
    </svg>
  );
};

export const IconsMinus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 -960 960 960"
      width="20px"
      fill="#000000"
    >
      <path d="M232-444v-72h496v72H232Z" />
    </svg>
  );
};

export const IconsAdd = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="20px"
      fill="#000000"
    >
      <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
    </svg>
  );
};

export const IconsGlobe = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M8 1.3335C4.3181 1.3335 1.33334 4.31826 1.33334 8.00016C1.33334 11.6821 4.3181 14.6668 8 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8 1.3335Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />

      <path
        d="M1.99998 5.6665H14"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      <path
        d="M1.99998 10.3335H14"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      <path
        d="M8 1.6665C9.52545 3.48953 10.3599 5.79153 10.3599 8.16984C10.3599 10.5481 9.52545 12.8501 8 14.6732"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      <path
        d="M8 1.6665C6.47455 3.48953 5.64014 5.79153 5.64014 8.16984C5.64014 10.5481 6.47455 12.8501 8 14.6732"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IconsCurrency = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M11.6667 3.3335H5.33333C4.59695 3.3335 4 3.93045 4 4.66683C4 5.40321 4.59695 6.00016 5.33333 6.00016H10C10.7364 6.00016 11.3333 6.59711 11.3333 7.3335C11.3333 8.06988 10.7364 8.66683 10 8.66683H4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M8 2V12.6667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      <path
        d="M5.33334 12.6665H12"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IconsBookPopup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path d="M1 12.895L13 1" stroke="#888888" strokeWidth="1.2" />
      <path
        d="M13 12.895L0.999999 0.999977"
        stroke="#888888"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const IconsRefund = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.55 18L3.85 12.3L5.275 10.875L9.55 15.15L18.725 5.975L20.15 7.4L9.55 18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconsIsRefund = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 2L1 21H23L12 2ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IconsSelected = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18px"
      viewBox="0 -960 960 960"
      width="18px"
      fill="#ffffff"
    >
      <path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z" />
    </svg>
  );
};
export const IconsBase = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <mask
        id="mask0_4232_133"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="15"
      >
        <rect y="0.813477" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4232_133)">
        <path
          d="M0.583374 10.847C0.583374 10.5164 0.668443 10.2126 0.838582 9.93551C1.00872 9.65843 1.23476 9.44697 1.51671 9.30114C2.11949 8.99975 2.73199 8.77371 3.35421 8.62301C3.97643 8.47232 4.60837 8.39697 5.25004 8.39697C5.89171 8.39697 6.52365 8.47232 7.14587 8.62301C7.7681 8.77371 8.3806 8.99975 8.98337 9.30114C9.26532 9.44697 9.49136 9.65843 9.6615 9.93551C9.83164 10.2126 9.91671 10.5164 9.91671 10.847V11.3136C9.91671 11.6345 9.80247 11.9091 9.574 12.1376C9.34553 12.3661 9.07087 12.4803 8.75004 12.4803H1.75004C1.42921 12.4803 1.15455 12.3661 0.926082 12.1376C0.69761 11.9091 0.583374 11.6345 0.583374 11.3136V10.847ZM12.25 12.4803H10.7625C10.8695 12.3053 10.9497 12.1182 11.0032 11.9188C11.0566 11.7195 11.0834 11.5178 11.0834 11.3136V10.7303C11.0834 10.3025 10.9643 9.89176 10.7261 9.49801C10.4879 9.10426 10.15 8.76642 9.71254 8.48447C10.2084 8.54281 10.675 8.64246 11.1125 8.78343C11.55 8.9244 11.9584 9.09697 12.3375 9.30114C12.6875 9.49558 12.9549 9.7119 13.1396 9.9501C13.3243 10.1883 13.4167 10.4484 13.4167 10.7303V11.3136C13.4167 11.6345 13.3025 11.9091 13.074 12.1376C12.8455 12.3661 12.5709 12.4803 12.25 12.4803ZM5.25004 7.81364C4.60837 7.81364 4.05907 7.58517 3.60212 7.12822C3.14518 6.67128 2.91671 6.12197 2.91671 5.48031C2.91671 4.83864 3.14518 4.28933 3.60212 3.83239C4.05907 3.37544 4.60837 3.14697 5.25004 3.14697C5.89171 3.14697 6.44101 3.37544 6.89796 3.83239C7.3549 4.28933 7.58337 4.83864 7.58337 5.48031C7.58337 6.12197 7.3549 6.67128 6.89796 7.12822C6.44101 7.58517 5.89171 7.81364 5.25004 7.81364ZM11.0834 5.48031C11.0834 6.12197 10.8549 6.67128 10.398 7.12822C9.94101 7.58517 9.39171 7.81364 8.75004 7.81364C8.6431 7.81364 8.50699 7.80149 8.34171 7.77718C8.17643 7.75288 8.04032 7.72614 7.93337 7.69697C8.19587 7.38586 8.39761 7.04072 8.53858 6.66156C8.67955 6.28239 8.75004 5.88864 8.75004 5.48031C8.75004 5.07197 8.67955 4.67822 8.53858 4.29906C8.39761 3.91989 8.19587 3.57475 7.93337 3.26364C8.06949 3.21503 8.2056 3.18343 8.34171 3.16885C8.47782 3.15426 8.61393 3.14697 8.75004 3.14697C9.39171 3.14697 9.94101 3.37544 10.398 3.83239C10.8549 4.28933 11.0834 4.83864 11.0834 5.48031ZM1.75004 11.3136H8.75004V10.847C8.75004 10.74 8.7233 10.6428 8.66983 10.5553C8.61636 10.4678 8.54587 10.3998 8.45837 10.3511C7.93337 10.0886 7.40351 9.89176 6.86879 9.76051C6.33407 9.62926 5.79449 9.56364 5.25004 9.56364C4.7056 9.56364 4.16601 9.62926 3.63129 9.76051C3.09657 9.89176 2.56671 10.0886 2.04171 10.3511C1.95421 10.3998 1.88372 10.4678 1.83025 10.5553C1.77678 10.6428 1.75004 10.74 1.75004 10.847V11.3136ZM5.25004 6.64697C5.57087 6.64697 5.84553 6.53274 6.074 6.30426C6.30247 6.07579 6.41671 5.80114 6.41671 5.48031C6.41671 5.15947 6.30247 4.88482 6.074 4.65635C5.84553 4.42788 5.57087 4.31364 5.25004 4.31364C4.92921 4.31364 4.65455 4.42788 4.42608 4.65635C4.19761 4.88482 4.08337 5.15947 4.08337 5.48031C4.08337 5.80114 4.19761 6.07579 4.42608 6.30426C4.65455 6.53274 4.92921 6.64697 5.25004 6.64697Z"
          fill="#888888"
        />
      </g>
    </svg>
  );
};

export const IconsMax = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <mask
        id="mask0_4232_138"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="15"
      >
        <rect y="0.313477" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4232_138)">
        <path
          d="M7.00004 7.31364C6.35837 7.31364 5.80907 7.08517 5.35212 6.62822C4.89518 6.17128 4.66671 5.62197 4.66671 4.98031C4.66671 4.33864 4.89518 3.78933 5.35212 3.33239C5.80907 2.87544 6.35837 2.64697 7.00004 2.64697C7.64171 2.64697 8.19101 2.87544 8.64796 3.33239C9.1049 3.78933 9.33337 4.33864 9.33337 4.98031C9.33337 5.62197 9.1049 6.17128 8.64796 6.62822C8.19101 7.08517 7.64171 7.31364 7.00004 7.31364ZM2.33337 10.8136V10.347C2.33337 10.0164 2.41844 9.7126 2.58858 9.43551C2.75872 9.15843 2.98476 8.94697 3.26671 8.80114C3.86949 8.49975 4.48199 8.27371 5.10421 8.12301C5.72643 7.97232 6.35837 7.89697 7.00004 7.89697C7.64171 7.89697 8.27365 7.97232 8.89587 8.12301C9.5181 8.27371 10.1306 8.49975 10.7334 8.80114C11.0153 8.94697 11.2414 9.15843 11.4115 9.43551C11.5816 9.7126 11.6667 10.0164 11.6667 10.347V10.8136C11.6667 11.1345 11.5525 11.4091 11.324 11.6376C11.0955 11.8661 10.8209 11.9803 10.5 11.9803H3.50004C3.17921 11.9803 2.90455 11.8661 2.67608 11.6376C2.44761 11.4091 2.33337 11.1345 2.33337 10.8136ZM3.50004 10.8136H10.5V10.347C10.5 10.24 10.4733 10.1428 10.4198 10.0553C10.3664 9.96781 10.2959 9.89975 10.2084 9.85114C9.68337 9.58864 9.15351 9.39176 8.61879 9.26051C8.08407 9.12926 7.54449 9.06364 7.00004 9.06364C6.4556 9.06364 5.91601 9.12926 5.38129 9.26051C4.84657 9.39176 4.31671 9.58864 3.79171 9.85114C3.70421 9.89975 3.63372 9.96781 3.58025 10.0553C3.52678 10.1428 3.50004 10.24 3.50004 10.347V10.8136ZM7.00004 6.14697C7.32087 6.14697 7.59553 6.03274 7.824 5.80426C8.05247 5.57579 8.16671 5.30114 8.16671 4.98031C8.16671 4.65947 8.05247 4.38482 7.824 4.15635C7.59553 3.92788 7.32087 3.81364 7.00004 3.81364C6.67921 3.81364 6.40455 3.92788 6.17608 4.15635C5.94761 4.38482 5.83337 4.65947 5.83337 4.98031C5.83337 5.30114 5.94761 5.57579 6.17608 5.80426C6.40455 6.03274 6.67921 6.14697 7.00004 6.14697Z"
          fill="#888888"
        />
      </g>
    </svg>
  );
};

export const IconsMaxChild = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <mask
        id="mask0_4232_143"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="15"
      >
        <rect y="0.313477" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4232_143)">
        <path
          d="M7 4.40625C6.67778 4.40625 6.40278 4.2888 6.175 4.05391C5.94722 3.81901 5.83333 3.53542 5.83333 3.20312C5.83333 2.87083 5.94722 2.58724 6.175 2.35234C6.40278 2.11745 6.67778 2 7 2C7.32222 2 7.59722 2.11745 7.825 2.35234C8.05278 2.58724 8.16667 2.87083 8.16667 3.20312C8.16667 3.53542 8.05278 3.81901 7.825 4.05391C7.59722 4.2888 7.32222 4.40625 7 4.40625ZM5.66667 12.3125V9.5625C5.47778 9.5625 5.31944 9.49661 5.19167 9.36484C5.06389 9.23307 5 9.06979 5 8.875V6.46875C5 6.09062 5.13056 5.76693 5.39167 5.49766C5.65278 5.22839 5.96667 5.09375 6.33333 5.09375H7.66667C8.03333 5.09375 8.34722 5.22839 8.60833 5.49766C8.86944 5.76693 9 6.09062 9 6.46875V8.875C9 9.06979 8.93611 9.23307 8.80833 9.36484C8.68056 9.49661 8.52222 9.5625 8.33333 9.5625V12.3125C8.33333 12.5073 8.26944 12.6706 8.14167 12.8023C8.01389 12.9341 7.85556 13 7.66667 13H6.33333C6.14444 13 5.98611 12.9341 5.85833 12.8023C5.73056 12.6706 5.66667 12.5073 5.66667 12.3125Z"
          fill="#888888"
        />
      </g>
    </svg>
  );
};

export const IconsHotelInfo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83301 6.66654C4.83301 5.82669 5.16664 5.02124 5.7605 4.42737C6.35437 3.83351 7.15982 3.49988 7.99967 3.49988C8.83953 3.49988 9.64498 3.83351 10.2388 4.42737C10.8327 5.02124 11.1663 5.82669 11.1663 6.66654C11.1663 7.5064 10.8327 8.31185 10.2388 8.90572C9.64498 9.49958 8.83953 9.83321 7.99967 9.83321C7.15982 9.83321 6.35437 9.49958 5.7605 8.90572C5.16664 8.31185 4.83301 7.5064 4.83301 6.66654ZM7.99967 4.49988C7.42504 4.49988 6.87394 4.72815 6.46761 5.13448C6.06128 5.54081 5.83301 6.09191 5.83301 6.66654C5.83301 7.24118 6.06128 7.79228 6.46761 8.19861C6.87394 8.60494 7.42504 8.83321 7.99967 8.83321C8.57431 8.83321 9.12541 8.60494 9.53174 8.19861C9.93807 7.79228 10.1663 7.24118 10.1663 6.66654C10.1663 6.09191 9.93807 5.54081 9.53174 5.13448C9.12541 4.72815 8.57431 4.49988 7.99967 4.49988Z"
        fill="#888888"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34926 5.90459C2.46321 4.52245 3.09274 3.23371 4.11287 2.29423C5.13299 1.35476 6.4691 0.833248 7.85593 0.833252H8.14393C9.53075 0.833248 10.8669 1.35476 11.887 2.29423C12.9071 3.23371 13.5366 4.52245 13.6506 5.90459C13.7774 7.44411 13.3018 8.97276 12.3239 10.1686L9.12859 14.0759C8.99185 14.2431 8.81965 14.3779 8.62445 14.4704C8.42926 14.5629 8.21594 14.6109 7.99993 14.6109C7.78391 14.6109 7.57059 14.5629 7.3754 14.4704C7.1802 14.3779 7.00801 14.2431 6.87126 14.0759L3.67593 10.1686C2.698 8.97279 2.22238 7.44412 2.34926 5.90459ZM7.85593 1.83325C6.72025 1.83342 5.62615 2.2606 4.79081 3.03C3.95546 3.79939 3.43995 4.85475 3.34659 5.98659C3.24099 7.26783 3.63678 8.54004 4.45059 9.53525L7.64593 13.4433C7.68888 13.4958 7.74298 13.5382 7.80432 13.5673C7.86566 13.5964 7.9327 13.6115 8.00059 13.6115C8.06848 13.6115 8.13552 13.5964 8.19686 13.5673C8.2582 13.5382 8.3123 13.4958 8.35526 13.4433L11.5506 9.53525C12.3639 8.53984 12.7592 7.26765 12.6533 5.98659C12.5599 4.85464 12.0443 3.79918 11.2088 3.02977C10.3733 2.26036 9.27905 1.83326 8.14326 1.83325H7.85526H7.85593Z"
        fill="#888888"
      />
    </svg>
  );
};

export const IconsAddress = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={styles.location_icon}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83301 6.66667C4.83301 5.82681 5.16664 5.02136 5.7605 4.4275C6.35437 3.83363 7.15982 3.5 7.99967 3.5C8.83953 3.5 9.64498 3.83363 10.2388 4.4275C10.8327 5.02136 11.1663 5.82681 11.1663 6.66667C11.1663 7.50652 10.8327 8.31197 10.2388 8.90584C9.64498 9.4997 8.83953 9.83333 7.99967 9.83333C7.15982 9.83333 6.35437 9.4997 5.7605 8.90584C5.16664 8.31197 4.83301 7.50652 4.83301 6.66667ZM7.99967 4.5C7.42504 4.5 6.87394 4.72827 6.46761 5.1346C6.06128 5.54093 5.83301 6.09203 5.83301 6.66667C5.83301 7.2413 6.06128 7.7924 6.46761 8.19873C6.87394 8.60506 7.42504 8.83333 7.99967 8.83333C8.57431 8.83333 9.12541 8.60506 9.53174 8.19873C9.93807 7.7924 10.1663 7.2413 10.1663 6.66667C10.1663 6.09203 9.93807 5.54093 9.53174 5.1346C9.12541 4.72827 8.57431 4.5 7.99967 4.5Z"
        fill="#888888"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34926 5.90471C2.46321 4.52258 3.09274 3.23383 4.11287 2.29436C5.13299 1.35488 6.4691 0.83337 7.85593 0.833374H8.14393C9.53075 0.83337 10.8669 1.35488 11.887 2.29436C12.9071 3.23383 13.5366 4.52258 13.6506 5.90471C13.7774 7.44423 13.3018 8.97288 12.3239 10.1687L9.12859 14.076C8.99185 14.2433 8.81965 14.378 8.62445 14.4705C8.42926 14.5631 8.21594 14.6111 7.99993 14.6111C7.78391 14.6111 7.57059 14.5631 7.3754 14.4705C7.1802 14.378 7.00801 14.2433 6.87126 14.076L3.67593 10.1687C2.698 8.97292 2.22238 7.44424 2.34926 5.90471ZM7.85593 1.83337C6.72025 1.83355 5.62615 2.26073 4.79081 3.03012C3.95546 3.79952 3.43995 4.85487 3.34659 5.98671C3.24099 7.26795 3.63678 8.54016 4.45059 9.53537L7.64593 13.4434C7.68888 13.4959 7.74298 13.6116 8.00059 13.6116C8.06848 13.6116 8.13552 13.5965 8.19686 13.5674C8.2582 13.5383 8.3123 13.4959 8.35526 13.4434L11.5506 9.53537C12.3639 8.53997 12.7592 7.26777 12.6533 5.98671C12.5599 4.85476 12.0443 3.79931 11.2088 3.02989C10.3733 2.26048 9.27905 1.83338 8.14326 1.83337H7.85526H7.85593Z"
        fill="#888888"
      />
    </svg>
  );
};
export const IconsAdult = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4137_1339"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <rect width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4137_1339)">
        <path d="M3.125 8.125V6.875H11.875V8.125H3.125Z" fill="#1C1B1F" />
      </g>
    </svg>
  );
};

export const IconsSelectedAddonAdult = () => {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.41667 10.75V6.08333H0.75V4.91667H5.41667V0.25H6.58333V4.91667H11.25V6.08333H6.58333V10.75H5.41667Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};

export const IconsChild = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4137_1339"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <rect width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4137_1339)">
        <path d="M3.125 8.125V6.875H11.875V8.125H3.125Z" fill="#1C1B1F" />
      </g>
    </svg>
  );
};

export const IconsSelectAddonQty = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4137_1339"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <rect width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4137_1339)">
        <path d="M3.125 8.125V6.875H11.875V8.125H3.125Z" fill="#1C1B1F" />
      </g>
    </svg>
  );
};

export const IconsDetails = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 13L13 1" stroke="#AAAAAA" strokeWidth="1.2" />
      <path d="M13 13L0.999999 1" stroke="#AAAAAA" strokeWidth="1.2" />
    </svg>
  );
};

export const IconsAddQty = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 13L13 1" stroke="#AAAAAA" strokeWidth="1.2" />
      <path d="M13 13L0.999999 1" stroke="#AAAAAA" strokeWidth="1.2" />
    </svg>
  );
};

export const IconsArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="white" />
      <path d="M15 7.5L10 12.5L15 17.5" stroke="black" strokeWidth="1.5" />
    </svg>
  );
};

export const IconsArrows = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <circle
        cx="12.5"
        cy="12.5"
        r="12.5"
        transform="rotate(180 12.5 12.5)"
        fill="white"
      />
      <path d="M10 17.5L15 12.5L10 7.5" stroke="black" strokeWidth="1.5" />
    </svg>
  );
};

export const IconsGallery = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#e8eaed"
    >
      <path d="M120-200q-33 0-56.5-23.5T40-280v-400q0-33 23.5-56.5T120-760h400q33 0 56.5 23.5T600-680v400q0 33-23.5 56.5T520-200H120Zm600-320q-17 0-28.5-11.5T680-560v-160q0-17 11.5-28.5T720-760h160q17 0 28.5 11.5T920-720v160q0 17-11.5 28.5T880-520H720Zm40-80h80v-80h-80v80ZM120-280h400v-400H120v400Zm40-80h320L375-500l-75 100-55-73-85 113Zm560 160q-17 0-28.5-11.5T680-240v-160q0-17 11.5-28.5T720-440h160q17 0 28.5 11.5T920-400v160q0 17-11.5 28.5T880-200H720Zm40-80h80v-80h-80v80Zm-640 0v-400 400Zm640-320v-80 80Zm0 320v-80 80Z" />
    </svg>
  );
};

export const IconsPrice = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{
        transform: isOpenPriceBreakup ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.3s ease",
      }}
    >
      <path
        d="M10.3212 7.5905C10.2299 7.49683 10.1234 7.45 10.0017 7.45C9.88008 7.45 9.77242 7.49683 9.67875 7.5905L7.232 10.0373C7.08633 10.1829 7.0505 10.3478 7.1245 10.5318C7.1985 10.7158 7.33908 10.8078 7.54625 10.8078L12.4582 10.8078C12.6629 10.8078 12.8022 10.7158 12.876 10.5318C12.9497 10.3478 12.9137 10.1829 12.768 10.0373L10.3212 7.5905ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};

export const IconsProceed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <mask
        id="mask0_4232_690"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="16"
      >
        <rect
          width="16"
          height="16"
          transform="matrix(-1 0 0 1 16.5 0)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4232_690)">
        <path
          d="M10.1335 8.00007L5.23353 12.9001C5.06686 13.0667 4.98631 13.2612 4.99186 13.4834C4.99742 13.7056 5.08353 13.9001 5.2502 14.0667C5.41686 14.2334 5.61131 14.3167 5.83353 14.3167C6.05575 14.3167 6.2502 14.2334 6.41686 14.0667L11.5502 8.95007C11.6835 8.81674 11.7835 8.66674 11.8502 8.50007C11.9169 8.33341 11.9502 8.16674 11.9502 8.00007C11.9502 7.83341 11.9169 7.66674 11.8502 7.50007C11.7835 7.33341 11.6835 7.18341 11.5502 7.05007L6.41686 1.91674C6.2502 1.75007 6.05297 1.66952 5.8252 1.67507C5.59742 1.68063 5.4002 1.76674 5.23353 1.93341C5.06686 2.10007 4.98353 2.29452 4.98353 2.51674C4.98353 2.73896 5.06686 2.93341 5.23353 3.10007L10.1335 8.00007Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const IconsPhone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#1A1A1A"
    >
      <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" />
    </svg>
  );
};

export const IconRotate = ({ style, width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "20"}
      height={height ? height : "20"}
      viewBox="0 0 20 20"
      fill="none"
      style={style ? style : null}
    >
      <path
        d="M10.3212 7.5905C10.2299 7.49683 10.1234 7.45 10.0017 7.45C9.88008 7.45 9.77242 7.49683 9.67875 7.5905L7.232 10.0373C7.08633 10.1829 7.0505 10.3478 7.1245 10.5318C7.1985 10.7158 7.33908 10.8078 7.54625 10.8078L12.4582 10.8078C12.6629 10.8078 12.8022 10.7158 12.876 10.5318C12.9497 10.3478 12.9137 10.1829 12.768 10.0373L10.3212 7.5905ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
        fill={color ? color : "#1C1B1F"}
      />
    </svg>
  );
};

export const IconsAddRoom = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.46967 5.46967C0.176777 5.76256 0.176777 6.23744 0.46967 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.46967 5.46967ZM1 6.75H13V5.25H1V6.75Z"
        fill="#222222"
      />
    </svg>
  );
};
